<div
  class="weather-legend"
  [class.weather-legend--raised]="isRaised"
  [class.weather-legend--compact]="isCompactLegend"
  [class.weather-legend--embedded]="embedded"
  *ngIf="isVisible">
  <div class="legend-title" [innerHTML]="getWeatherLegendTitleHtml()"></div>

  <!-- Gradient Scale -->
  <div *ngIf="isGradientWeatherLayer && legendItems.length"
       class="weather-scale-gradient"
       [class.temperature-gradient]="weatherLayerBaseName.includes('temperature') || weatherLayerBaseName.includes('frost')">
    <div class="gradient-bar"
         [class]="'gradient-' + weatherLayerBaseName"
         [style.background]="displayedGradient"></div>
    <div class="gradient-scale-labels">
      <span *ngFor="let item of legendItems; let i = index; let last = last"
            class="gradient-scale-label"
            [class.gradient-scale-label--first]="i === 0"
            [class.gradient-scale-label--last]="last"
            [class.gradient-scale-label--middle]="i > 0 && !last">{{ formatLegendScaleValue(item.value) }}</span>
    </div>
  </div>

  <!-- Discrete Scale -->
  <div *ngIf="isDiscreteScaleWeatherLayer && legendItems.length" class="weather-scale">
    <div class="legend-item" *ngFor="let item of legendItems">
      <div class="color-box" [style.background]="item.color"></div>
      <span class="legend-value">{{ getTranslatedValue(item.value) }}</span>
      <span *ngIf="item.rangeKey" class="legend-range">{{ item.rangeKey | translate: item.rangeParams }}</span>
    </div>
  </div>
</div>
